/**
 * @module FE-CU03_2段階認証画面
 */
import Header from '../../../components/header/Header.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../../api/nativeApi';
import NativeCallback from '../../../api/nativeCallback';

const PAGE_ID = 'FE-CU03';

export default {
  name: 'TwoStepAuthentication',
  components: {
    Header,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.二段階認証'),
      mailDomain: '',
      password: '',
      passwordError: '',
      disableFlag: true,
      authLoadFlag: false,
      info1: vm.$vuetify.lang.t(
        '$vuetify.FECU03二段階認証画面.ご登録いただいているメールアドレスに'
      ),
      info2: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.認証を完了させてください'),
      info3: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.ご利用の端末から'),
      info4: vm.$vuetify.lang.t(
        '$vuetify.FECU03二段階認証画面.メールが届かない場合は以下の可能性が考えられます'
      ),
      info5: vm.$vuetify.lang.t(
        '$vuetify.FECU03二段階認証画面.迷惑メールとして処理されている可能性があります'
      ),
      info6: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.ドメイン指定を行っている方は'),

      callbackResult: {
        accountInfo: {
          errorCode: '',
        },
      },
      // ログイン画面での入力情報を保持
      loginInfo: {
        userId: '',
        password: '',
      },
      // APIから取得した情報を保持
      terminalInfo: '',
      // バージョン情報を保持
      uiVersion: '',
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.二段階認証'),
        info1: vm.$vuetify.lang.t(
          '$vuetify.FECU03二段階認証画面.ご登録いただいているメールアドレスに',
          '【HOME ALSOK】ワンタイムパスワード送信'
        ),
        info2: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.認証を完了させてください', 30),
        info3: vm.$vuetify.lang.t('$vuetify.FECU03二段階認証画面.ご利用の端末から'),
        info4: vm.$vuetify.lang.t(
          '$vuetify.FECU03二段階認証画面.メールが届かない場合は以下の可能性が考えられます'
        ),
        info5: vm.$vuetify.lang.t(
          '$vuetify.FECU03二段階認証画面.迷惑メールとして処理されている可能性があります',
          '【HOME ALSOK】ワンタイムパスワード送信'
        ),
        info6: vm.$vuetify.lang.t(
          '$vuetify.FECU03二段階認証画面.ドメイン指定を行っている方は',
          `@${this.mailDomain}`
        ),
      };
    },
    version() {
      if (this.$isMobileApp) {
        return (
          'App Ver: ' +
          this.$store.getters['appInfo/getNativeVersion'] +
          '/ UI Ver: ' +
          this.uiVersion
        );
      } else {
        return 'Ver: ' + this.uiVersion;
      }
    },
    /**
     * 認証コード バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    passwordRule() {
      return [
        !!this.password ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU03二段階認証画面.E0002'),
      ];
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 登録処理
     */
    authenticate() {
      if (this.$isBrowser) {
        this.APP_CU0301();
      } else {
        this.APP_CU0302();
      }
    },
    /**
     * ユーザー権限一覧取得API実行処理
     */
    async APP_CU9916() {
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       customerNumber: "sendCustomerNumber",
            //       districtSplitNumber: "sendCustomerNumber",
            //       displayDistrictUserType: 1,
            //       userAuthority: {
            //         securityOperation: true,
            //         rushOrder: true,
            //         notificationHistory: true,
            //         deviceContorol: true,
            //         contact: true,
            //         nicknameSetting: true,
            //         IDCardKeyInfoSetting: true,
            //         watchOverInfoDeliverySetting: true,
            //         lockUpCheck: true,
            //         targetAtHomeSetting: true,
            //         userManagement: true,
            //         emergencyContact: true,
            //       },
            //     },
            //     cameraInfoList: {
            //       customerNumber: "customerNumber",
            //       districtSplitNumber: "districtSplitNumber",
            //       deviceID: "deviceID",
            //       cameraUserType: 0,
            //       userAuthority: {
            //         anticrimeCameraVideos: false,
            //         rushOrder: false,
            //         notificationHistory: false,
            //         contact: false,
            //         nicknameSetting: false,
            //         userManagement: false,
            //         emergencyContact: false,
            //       },
            //     },
            //   },
            // };

            if (apiData.contentsInfo.displayDistrictInfoList.length != 0) {
              this.$store.state.isTopHomeSecurityActive = true;
            }

            if (apiData.contentsInfo.cameraInfoList.length != 0) {
              this.$store.state.isTopCameraActive = true;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
    },
    /**
     * ワンタイムパスワード認証API実行処理
     * @returns apiData レスポンス
     */
    APP_CU0301: async function () {
      this.authLoadFlag = true;
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/twoStepAuthentication/oneTimePasswordAuthentication'; // 本番用
      // let param = "post"; // 検証用

      let queries = {
        token: sessionStorage.getItem('token') ?? this.$route.query.handoverToken, // JWTトークン
        oneTimePassword: this.password,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   terminalInfo: "terminalInfo",
            //   token: "token",
            // };

            this.$store.commit('setIsLoggedIn', { isLoggedIn: true });
            sessionStorage.setItem('token', apiData.token);
            localStorage.setItem('terminalInfo', apiData.terminalInfo);
            this.$cookie.set('token', apiData.token);

            // open target page in external browser
            if (this.$route.query.targetPage) {
              // 権限取得APP_CU9916
              await this.APP_CU9916(); // set value for isTopHomeSecurityActive and isTopCameraActive state => show icon in footer
              this.$router.push({
                path: this.$route.query.targetPage,
                query: { from: 'TwoStepAuthentication' },
              });
            } else {
              // トップ画面に遷移する。
              this.$router.push({
                path: '/top',
                query: { from: 'TwoStepAuthentication' },
              });
            }
          },
          (error /* eslint-disable-line */) => {
            if (error.response.status == '400' || error.response.status == '401') {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU03二段階認証画面.E0001');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
          this.authLoadFlag = false;
        });

      return apiData;
    },
    /**
     * ワンタイムパスワード認証(アプリ)API実行処理
     * @returns apiData レスポンス
     */
    APP_CU0302: async function () {
      this.authLoadFlag = true;
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/twoStepAuthentication/appOneTimePasswordAuthentication'; // 本番用
      // let param = "post"; // 検証用

      let queries = {
        token: sessionStorage.getItem('token'), // JWTトークン
        oneTimePassword: this.password,
        deviceToken: this.$store.getters['appInfo/getDeviceToken'],
        deviceOS: this.$store.getters['appInfo/getDeviceOs'],
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   terminalInfo: "terminalInfo",
            //   token: "token",
            // };

            sessionStorage.setItem('token', apiData.token);
            localStorage.setItem('terminalInfo', apiData.terminalInfo);
            this.terminalInfo = apiData.terminalInfo;
            this.$cookie.set('token', apiData.token);

            // アカウント情報記録APIを実行する
            const id = this.loginInfo.userId;
            const pw = this.loginInfo.password;
            NativeApi.registerAccountInfo(id, pw, apiData.terminalInfo);
          },
          (error /* eslint-disable-line */) => {
            if (error.response.status == '400' || error.response.status == '401') {
              // エラーメッセージ(FE-CU3-E0001)を表示する。
              this.$errorDialog('$vuetify.メッセージ一覧.FECU03二段階認証画面.E0001');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
          this.authLoadFlag = false;
        });

      return apiData;
    },
    /**
     * ログイン画面から渡されたid/terminalInfoのペアが、すでに保存されているid/terminalinfoのペアと完全に一致しているかを確認する
     * @returns {Boolean} 初回ログインかどうか
     */
    isFirstUser: function () {
      const sameUserId = this.loginInfo.userId === this.$store.getters['appInfo/getUserId'];
      const sameTerminaInfo = this.terminalInfo === localStorage.getItem('terminalInfo');

      //#29011 生体認証/パスコード認証時、2段階認証を行ったかフラグ確認
      let invalidTerminalInfoForBiometricAuth = localStorage.getItem(
        'invalidTerminalInfoForBiometricAuth'
      );
      //#29011 保険 使ったら削除
      localStorage.removeItem('invalidTerminalInfoForBiometricAuth');

      //#29011 生体認証/パスコード認証時、2段階認証を行ったら新規ログインとして扱う
      // 完全一致する場合は二度目のログインとみなす、そうではない場合は初回ログインとみなす
      return invalidTerminalInfoForBiometricAuth
        ? true
        : sameUserId && sameTerminaInfo
        ? false
        : true;
    },
    /**
     * 戻る処理
     */
    backBtn() {
      sessionStorage.removeItem('token');
      this.$store.commit('setIsLoggedIn', { isLoggedIn: false });
      this.$router.back();
    },
  },
  watch: {
    password: function (v) {
      if (v.length !== 6 || !/^[0-9]*$/.test(v)) {
        this.disableFlag = true;
      } else {
        this.disableFlag = false;
      }
    },

    // IF01NativeCallbackの完了を監視
    async 'callbackResult.accountInfo'(newVal, oldVal) {
      if (oldVal.errorCode !== '') return;
      if (NativeCallback.codeInclude(newVal.errorCode, '01-C0000')) {
        if (this.isFirstUser()) {
          localStorage.setItem('terminalInfo', this.terminalInfo);
          this.$router.push({
            path: '/loginSettings',
            query: { from: 'twoStepAuthentication' },
          });
        } else {
          localStorage.setItem('terminalInfo', this.terminalInfo);
          if (sessionStorage.getItem('redirectPath')) {
            // redirect to notificationHistory page when tap from panel
            this.$router.push({
              path: sessionStorage.getItem('redirectPath'),
            });
          } else {
            this.$router.push({
              path: '/top',
              query: { from: 'TwoStepAuthentication' },
            });
          }
        }
      } else if (NativeCallback.codeInclude(newVal.errorCode, '01-E9999')) {
        this.$router.push({
          path: '/sorry',
        });
      }
    },
    deep: true,
  },
  beforeMount() {
    // IF01_アカウント情報記録要求
    window.onRegisterAccountInfoFinished = (errorCode) => {
      this.callbackResult.accountInfo = NativeCallback.onRegisterAccountInfoFinished(errorCode);
    };
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 平文のパスワードをクエリパラメータで持っていたため、storeでの受け渡しに変更
    this.loginInfo = this.$store.getters['appInfo/getUsedLoginData'];

    // versionファイルの取得
    const file = require('raw-loader!@/../public/version');
    this.uiVersion = file.default;
    const url = new URL(window.location.href);
    this.mailDomain = url.hostname.replace('www.', '');
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
  beforeRouteLeave(to, _, next) {
    console.log(to);
    if (to.path == '/login') {
      sessionStorage.removeItem('token');
      this.$store.commit('setIsLoggedIn', { isLoggedIn: false });
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      next();
    } else {
      next();
    }
  },
};
